import { useState, useEffect } from "react";
import "../../SalesMasterPages/Estimate/Estimate.css";
import React from "react";
import MiniDrawer from "../../../components/MiniDrawer/MiniDrawer";
import axios from "axios";
import Wrapper from "../../../components/UI/Wrapper";
import { useLocation } from "react-router-dom";
import image2Half from "../../../images/Estimate-Headert-half.jpg";
import image3Half from "../../../images/Estimate-Headert-half3.jpg";
import image3 from "../../../images/Aziz_sign-stamp-png (002).png";
import html2pdf from "html2pdf.js";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import numberToWords from 'number-to-words';

const Estimate = () => {
  //----------------------------------------------//
  const baseAPI = process.env.REACT_APP_API_URL;
  //----------------------------------------------//
  const [quotationResponse, setQuotationResponse] = useState([]);
  const [quotation, setQuotation] = useState([]);
  const [quotationTotal, setQuotationTotal] = useState([]);
  const location = useLocation();
  const heading = "Estimate";

  // --------------------add data section starts here-------------------

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    if (storedToken) {
      axios
        .get(
          `${baseAPI}userget/QuotationBuilder?relocation_id=${location.state.relocation_id}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          setQuotationResponse(response.data.data[0]);
                  })
        .catch((error) => {
          console.error("Error fetching Lead detail:", error);
        });
    }

    if (storedToken) {
      axios
        .get(
          `${baseAPI}userget/GetEstimate?relocation_id=${location.state.relocation_id}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          setQuotation(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching Lead detail:", error);
        });
    }

    getQuotationTotal(location.state.relocation_id);
  }, []);

  function getQuotationTotal(ID) {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    axios
      .get(`${baseAPI}userget/GetQuotationTotal?relocation_id=` + ID, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      })
      .then((response) => {
        //console.log(response.data.data);
        setQuotationTotal(response.data.data);
        console.error("Relocation ID", response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  }

  const downloadAsPDF = () => {
    const input = document.getElementById("pdf-content");

    html2canvas(input, { scale: 1 }) // Higher scale for better quality
      .then((canvas) => {
        const imgData = canvas.toDataURL("image/jpeg",0.7);
        const pdf = new jsPDF("p", "mm", "a4"); // Portrait, millimeters, A4 size
        
        const pageHeight = pdf.internal.pageSize.height;
        const contentHeight = canvas.height * (210 / canvas.width); // Adjusting to A4 width
        
        if (contentHeight > pageHeight) {
          // Content is taller than a single page
          const totalPages = Math.ceil(contentHeight / pageHeight);

          for (let page = 0; page < totalPages; page++) {
            if (page > 0) pdf.addPage(); // Add new page if not the first one
            const positionY = -page * pageHeight; // Position the image to create a new page
            pdf.addImage(
              imgData,
              "PNG",
              0,
              positionY,
              210,
              contentHeight
            );
          }
        } else {
          // Content fits on a single page
          pdf.addImage(imgData, "JPEG", 0, 0, 210, contentHeight);
        }

        pdf.save(`Estimate.pdf`);
      })
      .catch((error) => {
        console.error("Error generating PDF:", error);
      });
  };

  const saveAsPDF = () => {
    const input = document.getElementById("pdf-content");
  
    html2canvas(input, { scale: 1 }) // Higher scale for better quality
      .then((canvas) => {
        const imgData = canvas.toDataURL("image/jpeg",0.7);
        const pdf = new jsPDF("p", "mm", "a4"); // Portrait, millimeters, A4 size
        const contentHeight = canvas.height * (210 / canvas.width);
  
        pdf.addImage(imgData, "JPEG", 0, 0, 210, contentHeight);
        const pdfData = pdf.output("datauristring"); // Get the data URI for the PDF

        const storedToken = JSON.parse(localStorage.getItem("token"));
        const relocation_id = location.state.relocation_id;
  
        const mediaData = {
          type: "pdf",
          pdf_path: pdfData, // Save the base64 representation of the PDF
          relocation_id: relocation_id,
        };
  
  
        axios.post(`${baseAPI}UserPost/UploadPdfData`, mediaData, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
          .then((response) => {
            console.log("Successfully saved PDF to database:", response.data);
            // Add any additional handling here, like updating the UI
            sendEmail();
          })
          .catch((error) => {
            console.error("Error posting data:", error);
            // Handle error appropriately, like displaying a user-friendly message
          });
      })
      .catch((error) => {
        console.error("Error generating PDF:", error);
        // Handle error appropriately
      });

  };

  const sendEmail = () => {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    if (storedToken) {
      axios.post(`${baseAPI}userpost/SendEmailWithAttachment`,
      {},
      {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      })
      .then((response) => {
        console.log(response.data.data);
        
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
    }
  };
  

  return (
    <div>
      <div className="app-container-Estimate">
        <MiniDrawer />
        <div className="container-fluid container-Estimate">
          <br />
          {/* ------------------------lead deatil--------------------- */}
          <br />
          <div>
            <Wrapper className="ViewLeadDetails">
              <div className="container-fluid" id="pdf-content">
                <table style={{ border: "1px solid #DEE2E6" }}>
                  <tr>
                    <td colSpan={7}>
                      <div style={{ width: "251px" }}>
                        <img
                          alt="Loading..."
                          className="estimate-header-image"
                          src={image3Half}
                        />
                      </div>
                    </td>
                    <td colSpan={3} style={{ paddingLeft: "26rem" }}>
                      <tr><h3>DBB WORLDWIDE PVT LTD</h3></tr>
                      <tr>S/F , 49 , KISHAN KUNJ EXTN ,LAXMI NAGAR</tr>

                      <tr>New Delhi- 110092 India</tr>
                      <tr>
                        <span style={{ fontWeight: "" }}>COMPANY ID:</span>{" "}
                        U60300DL2015PTC276446
                      </tr>
                      <tr>
                        <span>PAN :</span> AAFCD2475A
                      </tr>
                      <tr>
                        <span>TAN NO:</span> DELD18575E
                      </tr>
                      <tr>
                        <span>GSTIN:</span> 07AAFCD2475A1Z1
                      </tr>
                    </td>
                    <td colSpan={5}>
                      <div>
                        <h1>Estimate</h1>
                      </div>
                    </td>
                  </tr>
                </table>
                <div className="SalesTarget">
                  <table style={{ border: "1px solid #DEE2E6" }}>
                    <tr>
                      {/* <td>
                        <div style={{ width: "251px" }}>
                          <img
                            alt="Loading..."
                            className="estimate-header-image"
                            src={images2}
                          />
                        </div>
                      </td> */}
                    </tr>
                    <tr>
                      <td colSpan={5}>
                        <tr>
                          Estimate# :{" "}
                          <span style={{ fontWeight: "bold" }}>
                            {quotationResponse.estimate}
                          </span>
                        </tr>
                        <tr>
                          Estimate Date:{" "}
                          <span style={{ fontWeight: "bold" }}>
                            {quotationResponse.estimate_date}
                          </span>
                        </tr>
                        <tr>
                          Expiry Date:{" "}
                          <span style={{ fontWeight: "bold" }}>
                            {" "}
                            {quotationResponse.estimate_expiry_date}
                          </span>
                        </tr>
                      </td>
                      <td colSpan={6}>
                        <tr>
                          Place Of Supply :{" "}
                          <span style={{ fontWeight: "bold" }}>
                            {" "}
                            {quotationResponse.place_of_supply} (07)
                          </span>
                        </tr>
                        <tr>
                          Chargeable Weight in KG:{" "}
                          <span style={{ fontWeight: "bold" }}>
                            {quotationResponse.chargeable_wt}
                          </span>
                        </tr>
                        <tr>
                          Source City:{" "}
                          <span style={{ fontWeight: "bold" }}>
                            {" "}
                            {quotationResponse.port_of_loading}
                          </span>
                        </tr>
                        <tr>
                          Destination City:{" "}
                          <span style={{ fontWeight: "bold" }}>
                            {quotationResponse.port_of_discharge}
                          </span>
                        </tr>
                        <tr>
                          Mode:{" "}
                          <span style={{ fontWeight: "bold" }}>
                            {quotationResponse.mode_of_transport}
                          </span>
                        </tr>
                        <tr>
                          Airline Name :{" "}
                          <span style={{ fontWeight: "bold" }}>
                            {" "}
                            {quotationResponse.airline_name}
                          </span>
                        </tr>
                        <tr>
                          Est Created By :{" "}
                          <span style={{ fontWeight: "bold" }}>
                            {" "}
                            {quotationResponse.est_created_by}
                          </span>
                        </tr>
                      </td>
                    </tr>
                    <tr className="EstimateHeading">
                      <td colSpan={11}>Bill To</td>
                    </tr>
                    <tr>
                      <td colSpan={11} style={{ fontWeight: "bold" }}>
                        Customer Name : {" "}
                        <span>{quotationResponse.owner_name}</span>
                      </td>
                    </tr>
                    <tr className="EstimateHeading">
                      <th rowSpan={2}>S No.</th>
                      <th rowSpan={2}>Item & Description</th>
                      <th rowSpan={2}>HSN/SAC</th>
                      <th rowSpan={2}>Quantity</th>
                      <th rowSpan={2}>Rate</th>
                      <th rowSpan={2}>Taxable Amount</th>
                      <th colSpan={2}>CGST</th>
                      <th colSpan={2}>SGST</th>
                      <th rowSpan={2}>Total</th>
                    </tr>
                    <tr className="EstimateHeading">
                      <th>%</th>
                      <th>Amount</th>
                      <th>%</th>
                      <th>Amount</th>
                    </tr>
                    {quotation !== null ? (
                      quotation.map((Lead, index) => (
                        <>
                          <tr key={Lead.customer_id}>
                            <td>{++index}</td>
                            <td>{Lead.description}</td>
                            <td></td>
                            <td>{Lead.quantity}</td>
                            <td></td>
                            <td>{Lead.taxable_amount}</td>
                            <td>18%</td>
                            <td>{Lead.GST}</td>
                            <td>18%</td>
                            <td></td>
                            <td>{Lead.Total}</td>
                          </tr>
                        </>
                      ))
                    ) : (
                      <p>empty</p>
                    )}
                    {quotationTotal !== null ? (
                      quotationTotal.map((Total) => (
                        <>
                          <tr key={Total.customer_id}>
                            <td style={{ textAlign: "right" }} colSpan={5}>
                              Sub Total
                            </td>
                            <td></td>
                            <td colSpan={2}>{Total.total_taxable_amount}</td>
                            <td colSpan={2}>{Total.total_gst}</td>
                            <td>{Total.final_total}</td>
                          </tr>
                        </>
                      ))
                    ) : (
                      <p>empty</p>
                    )}
                    {quotationTotal !== null ? (
                      quotationTotal.map((Total) => (
                        <>
                          <tr>
                            <td style={{ textAlign: "left" }} colSpan={5}>
                              <tr>Total In Words</tr>
                              <tr style={{ fontWeight: "bold" }}>
                                {numberToWords.toWords(Total.final_total)}
                              </tr>
                              <br />
                              <br />
                              <tr>Looking forward for your business.</tr>
                              <br />
                              <tr>BANK NAME : ICICI BANK</tr>
                              <tr>A/C NAME: DBB WORLDWIDE PVT LTD</tr>
                              <tr>A/C NO: 003705017452</tr>
                              <tr>IFSC CODE: ICIC0000831</tr>
                              <tr>BRANCH: LAXMI NAGAR</tr>
                              <tr>SWIFT CODE: ICICINBBCTS</tr>
                            </td>
                            {/* only this part is not responsive */}
                            <td colSpan={6}>
                              <tr>
                                <span>Rounding</span>

                                <span style={{ paddingLeft: "30rem" }}>
                                  -0.8
                                </span>
                              </tr>
                              <tr>
                                <span style={{ fontWeight: "bold" }}>
                                  Total
                                </span>

                                <span
                                  style={{
                                    paddingLeft: "31rem",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {Total.final_total}
                                </span>
                              </tr>
                              <hr />
                              <br />
                              <tr>
                                <div style={{ paddingLeft: "2.5rem" }}>
                                  <div style={{ paddingLeft: "13rem" }}>
                                    <span>For DBB Worldwide Pvt Ltd</span>
                                  </div>
                                  <div
                                    style={{
                                      paddingLeft: "11rem",
                                      paddingTop: "0.5rem",
                                    }}
                                  >
                                    <img
                                      alt="Loading..."
                                      className="sign-image"
                                      src={image3}
                                    />
                                  </div>
                                  <div style={{ paddingLeft: "14.5rem" }}>
                                    <span>Authorized Signature</span>
                                  </div>
                                </div>
                              </tr>
                            </td>
                            {/* only this part is not responsive */}
                          </tr>
                        </>
                      ))
                    ) : (
                      <p>empty</p>
                    )}
                  </table>
                </div>
              </div>
              <div style={{display:"flex",flexDirection: "row-reverse"}}>
              <button
                style={{ marginTop: "1rem" }}
                onClick={() => saveAsPDF()}
              >
                Save
              </button>
              <button
                style={{ marginTop: "1rem", marginRight:"17px" }}
                onClick={() => downloadAsPDF()}
              >
                Download as PDF
              </button>
              </div>
            </Wrapper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Estimate;
